









































































































































































































































































































































































































import { defineComponent, ref, reactive, computed, Ref, set } from "@vue/composition-api";
import CollectionViewer from "@/components/CollectionViewer.vue";
import {
  AmountType,
  Business,
  BusinessConverter,
  BusinessEditable,
  InvoicingType,
  AddonState,
  Plan,
} from "@/composables/business/types";
import firebaseService from "@/services/firebase";
import DetailDialog from "@/components/DetailDialog.vue";
import BusinessEditor from "@/components/BusinessEditor.vue";
import moment from "moment";
import useUser from "@/composables/user";

interface EshopRow {
  id: string;
  business_id: string;
  shoptet_addon_state: string;
  email: string;
  tarif: string;
  active: boolean;
  has_api: boolean;
  eshop: string;
  eshop_url: string;
  price_list: string;
  first_installed_at: Date | null;
  stripe_id: string | null;
  fakturoid_id: string | null;
  fix_amount: number | null;
  prepay: boolean;
  next_prepay_date: Date | null;
  next_payment: number | null;
  currency: string;
  blocked: boolean;
  sortiment: string;
  features: Record<string, boolean>;
  sync_version: number;
  createdat?: Date;
  updatedat?: Date;
  trial?: boolean;
}

interface FilterState {
  searchTerm: string;
  addon_state: string;
  tarif: string;
  has_api: boolean | null;
  active: boolean | null;
  price_list: string;
  blocked: boolean | null;
  trial: boolean | null;
  sortiment: string;
  vip: boolean | null;
  referral: boolean | null;
  products_for_points: boolean | null;
}

const FEATURE_ICONS: Record<string, string> = {
  "limit-discount": "fas fa-percent",
  "manual-sync": "fas fa-sync",
  "delayed-recharge": "fas fa-clock",
  "apps-smartmailling": "fas fa-envelope",
  "apps-leadhub": "fas fa-bullseye",
  "frontend-visibility": "fas fa-eye",
  "minimal-total": "fas fa-shopping-cart",
  "unlimited-orders": "fas fa-infinity",
  "expiration": "fas fa-calendar-times",
  "registration": "fas fa-user-plus",
  "newsletter": "fas fa-newspaper",
  "product-coefficient": "fas fa-box",
  "brand-category-coefficient": "fas fa-tags",
  "extended-support": "fas fa-headset",
  "vip": "fas fa-star",
  "referral": "fas fa-users",
  "products-for-points": "fas fa-coins",
};

export default defineComponent({
  components: {
    CollectionViewer,
    DetailDialog,
    BusinessEditor,
  },
  setup(props: any, context: any) {
    const { user } = useUser();

    // --- Filter ---
    const showFilters = ref(false);
    const filter = reactive<FilterState>({
      searchTerm: "",
      addon_state: "",
      tarif: "",
      has_api: null,
      active: null,
      price_list: "",
      blocked: null,
      trial: null,
      sortiment: "",
      vip: null,
      referral: null,
      products_for_points: null,
    });

    const triStateOptions = [
      { text: "Ano", value: true },
      { text: "Ne", value: false },
    ];

    const tarifOptions = Object.values(Plan);
    const priceListOptions = ["v0", "v1", "v2", "v3"];
    const addonStateOptions = Object.values(AddonState);
    const sortimentOptions = [
      "Fashion & Accessories",
      "Beauty & Personal Care",
      "Home & Garden",
      "Electronics",
      "Food & Nutrition",
      "Hobby & Leisure",
      "Baby & Family",
      "Auto & Motorcycle",
    ];

    const hasActiveFilters = computed(() =>
      !!(filter.searchTerm || filter.addon_state || filter.tarif ||
        filter.has_api !== null || filter.active !== null || filter.price_list ||
        filter.blocked !== null || filter.trial !== null || filter.sortiment ||
        filter.vip !== null || filter.referral !== null ||
        filter.products_for_points !== null)
    );

    const clearFilters = () => {
      filter.searchTerm = "";
      filter.addon_state = "";
      filter.tarif = "";
      filter.has_api = null;
      filter.active = null;
      filter.price_list = "";
      filter.blocked = null;
      filter.trial = null;
      filter.sortiment = "";
      filter.vip = null;
      filter.referral = null;
      filter.products_for_points = null;
      search();
    };

    const buildFilter = () => {
      const f: Record<string, unknown> = {};
      if (filter.searchTerm) f.searchTerm = filter.searchTerm;
      if (filter.addon_state) f.addon_state = filter.addon_state;
      if (filter.tarif) f.tarif = filter.tarif;
      if (filter.has_api !== null) f.has_api = filter.has_api;
      if (filter.active !== null) f.active = filter.active;
      if (filter.price_list) f.price_list = filter.price_list;
      if (filter.blocked !== null) f.blocked = filter.blocked;
      if (filter.trial !== null) f.trial = filter.trial;
      if (filter.sortiment) f.sortiment = filter.sortiment.toLowerCase();
      if (filter.vip !== null) f.vip = filter.vip;
      if (filter.referral !== null) f.referral = filter.referral;
      if (filter.products_for_points !== null) f.products_for_points = filter.products_for_points;
      return f;
    };

    // --- Initialize from route query ---
    const initFromRoute = () => {
      const route = context.root.$route;
      const q = (route && route.query && (route.query.search as string)) || "";
      if (q) filter.searchTerm = q;
    };
    initFromRoute();

    // --- Table data ---
    const page = ref(1);
    const itemsPerPage = ref(50);
    const items: Ref<EshopRow[]> = ref([]);
    const total = ref(0);
    const pageCount = computed(() => Math.ceil(total.value / itemsPerPage.value));
    const isLoading = ref(false);

    const headers = [
      { text: "", value: "expand", sortable: false, width: "36px" },
      { text: "Eshop", value: "eshop", sortable: true },
      { text: "E-mail", value: "email", sortable: true },
      { text: "Tarif", value: "tarif", sortable: true },
      { text: "Sortiment", value: "sortiment", sortable: true },
      { text: "Stav doplňku", value: "shoptet_addon_state", sortable: true },
      { text: "Trial", value: "trial", sortable: true },
      { text: "Aktivní", value: "active", sortable: true },
      { text: "Blokován", value: "blocked", sortable: true },
      { text: "1. instalace", value: "first_installed_at", sortable: true, width: "110px" },
      { text: "Další platba", value: "next_payment", sortable: true, width: "120px" },
      { text: "Další předplatné", value: "next_prepay_date", sortable: true, width: "130px" },
      { text: "", value: "actions", sortable: false, align: "end" },
    ];

    const sortBy = ref<string | null>(null);
    const sortDesc = ref(false);

    const onSortChange = (by: string[], desc: boolean[]) => {
      sortBy.value = by[0] ?? null;
      sortDesc.value = desc[0] ?? false;
      search();
    };

    const expandedIds = reactive<Record<string, boolean>>({});
    const toggleExpand = (id: string) => {
      set(expandedIds, id, !expandedIds[id]);
    };

    const snackbar = reactive({ show: false, text: "", color: "error" });
    const showError = (text: string) => {
      snackbar.text = text;
      snackbar.color = "error";
      snackbar.show = true;
    };

    const mapRow = (raw: any): EshopRow => ({
      id: raw.addonId ?? raw.id,
      business_id: raw.business_id,
      eshop: raw.company ?? raw.eshop ?? "",
      eshop_url: raw.eshopUrl ?? raw.eshop_url ?? "",
      email: raw.contactEmail ?? raw.email ?? "",
      shoptet_addon_state: raw.shoptetAddonState ?? raw.shoptet_addon_state ?? "",
      tarif: raw.plan ?? raw.tarif ?? "",
      features: Array.isArray(raw.features)
        ? Object.fromEntries((raw.features as string[]).map((f) => [f, true]))
        : (raw.features ?? {}),
      stripe_id: raw.stripeId ?? raw.stripe_id ?? null,
      fakturoid_id: raw.fakturoidId ?? raw.fakturoid_id ?? null,
      blocked: raw.blocked ?? false,
      active: raw.active ?? true,
      has_api: raw.has_api ?? false,
      price_list: raw.price_list ?? "",
      sortiment: raw.sortiment ?? "",
      currency: raw.currency ?? "",
      prepay: raw.prepay ?? false,
      fix_amount: raw.fix_amount ?? null,
      next_prepay_date: raw.next_prepay_date ?? null,
      next_payment: raw.next_payment ?? raw.nextPayment ?? null,
      first_installed_at: raw.first_installed_at ?? raw.firstInstalledAt ?? null,
      sync_version: raw.sync_version ?? 0,
      createdat: raw.createdat ?? raw.createdAt ?? raw.created_at ?? undefined,
      updatedat: raw.updatedat ?? raw.updatedAt ?? undefined,
      trial: raw.trial ?? undefined,
    });

    const fetchData = async () => {
      isLoading.value = true;
      try {
        const { data } = await firebaseService.admin("getAdminReportingData", {
          reportType: "query-accounts",
          parameters: {
            limit: itemsPerPage.value,
            offset: (page.value - 1) * itemsPerPage.value,
            filter: buildFilter(),
            ...(sortBy.value ? { orderBy: sortBy.value, order: sortDesc.value ? "DESC" : "ASC" } : {}),
          },
        });
        const raw = data.rows ?? data.results ?? [];
        items.value = raw.map(mapRow);
        total.value = data.total ?? raw.length;
      } finally {
        isLoading.value = false;
      }
    };

    const search = () => {
      if (page.value !== 1) {
        page.value = 1;
      }
      fetchData();
    };

    const onPageChange = (newPage: number) => {
      page.value = newPage;
      fetchData();
    };

    // --- Helpers ---
    const formatCurrency = (amount: number, currency: string): string => {
      return new Intl.NumberFormat('cs-CZ', { style: 'currency', currency: currency || 'CZK', maximumFractionDigits: 0 }).format(amount);
    };

    const formatDate = (val: Date | string | null): string => {
      if (!val) return '—';
      return moment(val).format('DD.MM.YYYY');
    };

    const featureIcon = (key: string) => FEATURE_ICONS[key] || "fas fa-puzzle-piece";

    const ADDON_STATE_COLORS: Record<string, string> = {
      active: "success",
      installed: "primary",
      uninstalled: "grey",
      suspended: "warning",
      blocked: "error",
    };
    const addonStateColor = (state: string) => ADDON_STATE_COLORS[state] || "grey";

    const trialDaysLeft = (item: EshopRow): number | null => {
      if (!item.trial || !item.createdat) return null;
      return moment(item.createdat).add(30, "days").diff(moment(), "days");
    };

    const trialText = (item: EshopRow): string => {
      if (!item.trial) return "ne";
      const days = trialDaysLeft(item);
      if (days === null) return "trial";
      return days > 0
        ? `zbývá ${days} dní`
        : `ukončen před ${days * -1} dny`;
    };

    const trialClass = (item: EshopRow): string => {
      if (!item.trial) return "success--text font-weight-medium";
      const days = trialDaysLeft(item);
      if (days === null) return "";
      if (days > 7) return "";
      if (days > 0) return "orange--text font-weight-bold";
      return "error--text";
    };

    const trialEndText = (item: EshopRow): string => {
      if (!item.createdat) return "";
      return `Konec trialu: ${moment(item.createdat)
        .add(30, "days")
        .format("DD.MM.YYYY")}`;
    };

    // --- Business load (on demand for edit) ---
    const businessConverter = new BusinessConverter();
    const loadBusiness = async (id: string): Promise<Business | undefined> => {
      const snap = await firebaseService
        .getDb()
        .collection("businesses")
        .doc(id)
        .withConverter(businessConverter)
        .get();
      return snap.data();
    };

    // --- Edit dialog ---
    const businessEditorDialog = ref(false);
    const businessEditable: Ref<BusinessEditable | null> = ref(null);

    const editBusiness = (business: Business) => {
      businessEditable.value = {
        original: business,
        contact: {
          email: business.contact.email,
          phone: business.contact.phone,
        },
        billing: business.billing
          ? {
              activatedAt: business.billing.activatedAt,
              stripe: business.billing.stripe
                ? { couponId: business.billing.stripe.couponId }
                : null,
              invoicingType: business.billing.invoicingType,
              amountType: business.billing.amountType,
              payType: business.billing.payType,
              fixAmount: business.billing.fixAmount,
              prepayMetadata: business.billing.prepayMetadata
                ? {
                    firstDayOfNextPaymentMonth:
                      business.billing.prepayMetadata.firstDayOfNextPaymentMonth,
                    hasAnnualPrices:
                      business.billing.prepayMetadata.hasAnnualPrices,
                    licencePrice: business.billing.prepayMetadata.licencePrice,
                    numberOfMonths:
                      business.billing.prepayMetadata.numberOfMonths,
                  }
                : null,
              blockedByPayment: business.billing.blockedByPayment,
              monthlyDiscount: business.billing.monthlyDiscount,
            }
          : null,
      };
      businessEditorDialog.value = true;
    };

    const handleEditBusiness = async (item: EshopRow) => {
      try {
        const business = await loadBusiness(item.business_id);
        if (business) {
          editBusiness(business);
        } else {
          showError(`Business ${item.business_id} nenalezen v Firebase.`);
        }
      } catch (e) {
        console.error(e);
        showError("Chyba při načítání business dat.");
      }
    };

    const updateBusiness = async () => {
      const original = businessEditable.value!.original;
      original.contact.email = businessEditable.value!.contact.email!;
      original.contact.phone = businessEditable.value!.contact.phone!;
      if (original.billing) {
        if (original.billing.stripe) {
          original.billing.stripe.couponId =
            businessEditable.value!.billing!.stripe!.couponId;
        }
        original.billing.activatedAt = businessEditable.value!.billing!.activatedAt;
        original.billing.invoicingType = businessEditable.value!.billing!.invoicingType;
        original.billing.amountType = businessEditable.value!.billing!.amountType;
        original.billing.payType = businessEditable.value!.billing!.payType;
        original.billing.fixAmount = businessEditable.value!.billing!.fixAmount;
        original.billing.monthlyDiscount = businessEditable.value!.billing!.monthlyDiscount;
        original.billing.prepayMetadata = businessEditable.value!.billing!
          .prepayMetadata
          ? {
              firstDayOfNextPaymentMonth:
                businessEditable.value!.billing!.prepayMetadata
                  .firstDayOfNextPaymentMonth,
              hasAnnualPrices:
                businessEditable.value!.billing!.prepayMetadata.hasAnnualPrices,
              licencePrice:
                businessEditable.value!.billing!.prepayMetadata.licencePrice,
              numberOfMonths:
                businessEditable.value!.billing!.prepayMetadata.numberOfMonths,
            }
          : null;
        original.billing.blockedByPayment =
          businessEditable.value!.billing!.blockedByPayment;
        if (
          original.billing!.invoicingType == InvoicingType.prepay &&
          original.billing!.amountType == AmountType.plan
        ) {
          throw new Error(
            "Předplatné na základě tržeb pouze pres konzoli klienta."
          );
        }
      }
      await firebaseService.updateBusiness(businessEditable.value!.original);
    };

    const loginAsEditableBusiness = () => {
      if (businessEditable.value) {
        loginAsBusiness(
          businessEditable.value.original.id,
          businessEditable.value.original.language
        );
      }
    };

    // --- Auth ---
    const loginAsBusiness = async (businessId: string, language: string) => {
      try {
        const result = await firebaseService.business("getAdminLoginUrl", {
          businessId,
          language,
        });
        window.open(result.link, "_blank");
      } catch (error) {
        console.log(error);
      }
    };

    // --- Exports ---
    const exportAccounts = async () => {
      const csv = await firebaseService.admin("getAdminReportingData", {
        reportType: "export-accounts",
      });
      const element = document.createElement("a");
      element.setAttribute(
        "href",
        "data:text/plain;charset=utf-8," + encodeURIComponent(csv.data)
      );
      element.setAttribute("download", "ellity-accounts.csv");
      element.style.display = "none";
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    };

    const exportAccountsToEcomail = async () => {
      const result = await firebaseService.admin("exportCustomers", {});
      console.log(result);
    };

    const exportAccountsToRaynet = async (businessId?: string) => {
      const result = await firebaseService.admin("exportCustomersRaynet", {
        businessId,
      });
      console.log(result);
    };

    const copyToClipboard = (str: string, label?: string) => {
      window.navigator.clipboard.writeText(str);
      if (label) {
        snackbar.text = label;
        snackbar.color = "success";
        snackbar.show = true;
      }
    };

    fetchData();

    return {
      user,
      showFilters,
      filter,
      triStateOptions,
      tarifOptions,
      priceListOptions,
      addonStateOptions,
      sortimentOptions,
      hasActiveFilters,
      clearFilters,
      pageCount,
      headers,
      expandedIds,
      toggleExpand,
      snackbar,
      items,
      total,
      isLoading,
      page,
      itemsPerPage,
      onPageChange,
      onSortChange,
      sortBy,
      sortDesc,
      search,
      formatDate,
      formatCurrency,
      featureIcon,
      addonStateColor,
      trialText,
      trialClass,
      trialEndText,
      fetchData,
      handleEditBusiness,
      businessEditorDialog,
      businessEditable,
      updateBusiness,
      loginAsBusiness,
      exportAccounts,
      exportAccountsToEcomail,
      exportAccountsToRaynet,
      copyToClipboard,
      loginAsEditableBusiness,
    };
  },
});
